import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import {
  FieldDefinitionModel,
  FieldType,
  ObjectDefinitionModel,
} from '@seahorse/domain';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ObjectPickerControl } from '../../controls/object-picker/object-picker.control';

@Component({
  selector: 'temp-object-picker-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, ObjectPickerControl],
  templateUrl: './object-picker-modal.component.html',
})
export class ObjectPickerModalComponent {
  @Input() fieldDefinition!: FieldDefinitionModel;
  @Input() externalObjectDefinition?: ObjectDefinitionModel;

  @Input() fieldKey = '';
  @Input() fieldName = '';
  @Input() isRequired = false;
  @Input() isDisabled = false;
  @Input() noValidate = false;

  @Input() isTable = true;
  @Input() initialValue: any = null;

  picked: any = null;
  isSubmitted = false;
  multiple = false;

  constructor(private modal: NgbActiveModal) {}

  ngOnInit() {
    this.picked = this.initialValue ?? null;
    this.multiple = this.fieldDefinition?.fieldType === FieldType.LinkedObjects;
  }

  cancel() {
    this.modal.dismiss();
  }

  confirm() {
    let valueToReturn: any;
    this.isSubmitted = true;

    if (
      this.isRequired &&
      (this.picked == null || (this.multiple && this.picked.length === 0))
    ) {
      return;
    }

    if (this.multiple) {
      valueToReturn = Array.isArray(this.picked)
        ? this.picked
        : this.picked != null
        ? [this.picked]
        : [];
    } else {
      valueToReturn = this.picked ?? null;
    }

    this.modal.close({ [this.fieldKey]: valueToReturn });
  }
}
